import { render, staticRenderFns } from "./ProjectCardMedia.vue?vue&type=template&id=2dc41d30&scoped=true"
import script from "./ProjectCardMedia.vue?vue&type=script&lang=ts"
export * from "./ProjectCardMedia.vue?vue&type=script&lang=ts"
import style0 from "./ProjectCardMedia.vue?vue&type=style&index=0&id=2dc41d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc41d30",
  null
  
)

export default component.exports